// App Configuration
// Update these values with your actual details

export const APP_CONFIG = {
  // API Configuration
  // Set to null or include 'your-backend' to skip API calls when no backend is running
  // Example: API_BASE_URL: 'https://api.yourcompany.com/api'
  API_BASE_URL: 'http://localhost:5001/api',

  // Calendly Configuration
  // Your Calendly scheduling link for 30-minute demo calls
  CALENDLY_URL: 'https://calendly.com/growthvalley05/30min',

  // Company Info
  COMPANY_NAME: 'TeleValley',
  COMPANY_EMAIL: 'contact@TeleValley.io',

  // Social Links
  WHATSAPP_NUMBER: '919876543210', // Without + sign
  WHATSAPP_MESSAGE: "Hi! I'm interested in TeleValley. Can you tell me more?",
};